import { parse, isValid } from 'date-fns';

export const date = (input) => {
  let dateComp = parse(input, "MM/dd/yyyy", new Date());
  return isValid(dateComp);
};

